import { AGENT_TOOL_PROVIDER_TOKEN } from "@tylertech/smart-pulse-core";
import type { MutableContainer, ReadonlyContainer, SmartPulsePlugin } from "@tylertech/smart-pulse-core";
import { CxBridgeService } from "./cxBridge.service";
import { CxEscalationTool } from "./cxEscalation.tool";
import { CX_ESCALATION_PROVIDER_TOKEN } from "./cxEscalation.token";

export function createCxEscalationPlugin(cxBridgeService: CxBridgeService): SmartPulsePlugin
{
    let deregister: (() => void) | undefined;

    return {
        id: "cx-escalation",
        requiresTokens: [AGENT_TOOL_PROVIDER_TOKEN],
        init(container: MutableContainer): void
        {
            container.register({
                token: CX_ESCALATION_PROVIDER_TOKEN,
                factory: () => ({
                    id: "cx-escalation",
                    provide: () => [new CxEscalationTool(cxBridgeService)]
                })
            });
        },
        afterInit(container: ReadonlyContainer): void
        {
            deregister = container.resolve(AGENT_TOOL_PROVIDER_TOKEN)
                .registerProvider(container.resolve(CX_ESCALATION_PROVIDER_TOKEN));
        },
        dispose(): void
        {
            deregister?.();
        }
    };
}
